import store from 'store2';
import assert from '../assert';
function storeFactory(key, prefix) {
  assert(typeof key === 'string' && !!key, '(@ovpn-ui/utils) storeFactory: Expected valid key');
  assert(typeof prefix === 'string' && !!prefix, '(@ovpn-ui/utils) storeFactory: Expected valid prefix');
  const generateKey = id => `${prefix}/${key}${id ? '/' : ''}${id || ''}`;
  return {
    transact: (fn, alt, id) => store.transact(generateKey(id), fn, alt),
    set: (value, id) => value ? store.set(generateKey(id), value) : store.remove(generateKey(id)),
    clear: id => store.remove(generateKey(id)),
    get: id => store.get(generateKey(id))
  };
}
export default storeFactory;